if (!window.customElements.get("gift-card-recipient")) {
  class GiftCardRecipient extends HTMLElement {
    constructor() {
      super()
      this.properties = Array.from(this.querySelectorAll('[name*="properties"]'))
      this.recipientCheckbox = this.querySelector("#recipient-checkbox-" + this.dataset.sectionId)
      this.recipientOtherProperties = this.properties.filter((input) => input.name !== this.recipientCheckbox.name)
      this.recipientFieldsContainer = this.querySelector(".gift-card-recipient-fields")
    }

    connectedCallback() {
      this.recipientCheckbox?.addEventListener("change", this.synchronizeProperties.bind(this))
      this.synchronizeProperties()
    }

    synchronizeProperties() {
      this.recipientOtherProperties.forEach((property, index) => {
        property.disabled = !this.recipientCheckbox.checked
      })

      this.recipientFieldsContainer.classList.toggle("no-js", !this.recipientCheckbox.checked)
    }
  }

  window.customElements.define("gift-card-recipient", GiftCardRecipient)
}
